import './public/nav.less'

import ReactDOM from 'react-dom/client'

import { Nav } from '../components/nav'

const rootEl = document.getElementById('nav-root')
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl)
  root.render(<Nav />)
}
